<template>
  <tabs parent="airalo_list">
    <tab id="simcard_list" :name="translate('airalo.simcard_list')" :href="url+'simcard_list'" >
      <SimcardList />
    </tab>

    <tab id="order_list" :name="translate('airalo.order_list')" :href="url+'order_list'" >
      <OrderList />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import SimcardList from './Tabs/SimcardList/Index.vue'
import OrderList from './Tabs/OrderList/Index.vue'

export default {
  name: 'Airalo',
  components:{
    Tab,
    Tabs,
    SimcardList,
    OrderList
  },
  props: {
  },
  data () {
    return {
      load: true,
    }
  },
  computed: {
    url () { return '/airalo_list/' }
  },

}
</script>
